import { Button, Container, Typography } from '@material-ui/core';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import CustomSelectEdit from 'components/CustomSelect/CutomSelectEscolaEdit';
import { Modal } from 'components/Modal';
import { NewAutoCompleteFieldCidades } from 'components/NewAutoCompleteField/NewAutoCompleteFieldCidades';
import { NewAutoCompleteFieldEstados } from 'components/NewAutoCompleteField/NewAutoCompleteFieldEstados';
import {
  ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL,
  ESCOLA_EDIT_FILTER_EJA,
  ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL,
  ESCOLA_EDIT_FILTER_ENSINO_MEDIO,
  ESCOLA_EDIT_FILTER_ESPECIALIZADO,
  ESCOLA_EDIT_FILTER_OUTRO,
} from 'library/EscolaEditCampoEtapaDaEducacao';
import {
  ESCOLA_EDIT_FILTER_ESTADUAL,
  ESCOLA_EDIT_FILTER_MUNICIPAL,
  ESCOLA_EDIT_FILTER_PRIVADA,
} from 'library/EscolaEditCampoTipoDeInstituicao.js';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { openModal } from 'store/modules/ModalActions';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';
import { Col } from '../../../../../components/Col';
import { CustomButton } from '../../../../../components/CustomButton';
import CustomTable from '../../../../../components/CustomTable/CustomTable';
import { CustomTextField } from '../../../../../components/CustomTextField';
import { HelpButton } from '../../../../../components/HelpButton';
import {
  CEPMaskedInput,
  CNPJMaskedInput,
  PhoneMaskedInput,
} from '../../../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import UnauthorizedScreen from '../../../../../components/UnauthorizedScreen/UnauthorizedScreen';
import { createEscolaRoute, escolaEditRoute, escolasRoute } from '../../../../../library/Routes';
import {
  changeEscolaEditingValue,
  checkSemelhantes,
  clearEscolaEditing,
  createEscola,
  getProgramaInfo,
  handleNext,
  loadEscolaById,
  loadModalidades,
  resetProgramaValue,
  saveEscola,
  setCurrentTab,
} from '../../../../../store/modules/EscolasActions';
import {
  createRede,
  loadCidadesByEstadoId,
  loadCooperativas,
  loadEstados,
  loadRedes,
} from '../../../../../store/modules/LogradouroActions';
import { isAuthorizedRequest } from '../../../../../utils/httpResponseHandlers';
import { getPropsToLabel } from '../../../../../utils/HelpButtonUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import { getUnmaskedValue } from '../../../../../utils/InputMaskUtils';
import {
  allIsTrue,
  BAIRRO_MAX_LENGTH,
  cepIsValid,
  cnpjSchema,
  COMPLEMENTO_MAX_LENGTH,
  cooperativaRequiredIsValid,
  EMAIL_MAX_LENGTH,
  emailIsValid,
  ENDERECO_MAX_LENGTH,
  estadoRequiredIsValid,
  etapaDaEducacaoRequiredIsValid,
  INEP_LENGTH,
  inepIsValid,
  maskedValueRequiredIsValid,
  NOME_FANTASIA_MAX_LENGTH,
  NUMERO_MAX_LENGTH,
  numeroIsValid,
  RAZAO_SOCIAL_MAX_LENGTH,
  redeRequiredIsValid,
  requiredIsValid,
  strCidadeRequiredIsValid,
  telefoneIsValid,
  tipoInstituicaoRequiredIsValid,
} from '../../../../../utils/ValidationUtils';
import { EscolaEditTabs } from '../ProgramasEducacionais/__enum';
import { CustomCard } from '../../../../../components/CustomCard';
import styles from './index.scss';
import { ESCOLA_ETAPAS_PARAMS_URL } from 'models/escola';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;
const rootElementId = 'escola-edit';

const INITIAL_STATE = {
  checkedVinculoRede: false,
  permiteCadastroRede: false,
  redes: [],
  redeSelecionada: null,
  redeInicializada: false,
  isRedeValid: {
    status: false,
    error: ''
  },
  openModalRede: false,
  cnpjRede: "",
  nomeRede: "",
  formRedeErrors: {
    nomeRede: '',
    cnpjRede: ''
  },
  loadingRedes: false,
  authorizedRequest: true,
  sending: false,
  loading: false,
  etapasDaEducacaoFocused: false,
  modalidadeFocused: false,
  etapasEducacao: [],
  modalidades: [],
  tipoDeInstuicaoChanged: false,
  etapasDaEducacaoChanged: false,
  modalidadeChanged: false,
  nomeFantasiaChanged: false,
  razaoSocialChanged: false,
  cnpjChanged: false,
  telefoneChanged: false,
  inepChanged: false,
  emailChanged: false,
  coopChanged: false,
  cepChanged: false,
  redeChanged: false,
  enderecoChanged: false,
  numeroChanged: false,
  complementoChanged: false,
  bairroChanged: false,
  estadoChanged: false,
  cidadeChanged: false,
  open: false,
  _isMounted: false,
};
class Informacoes extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;

    this.allTipoDeInstuicao = [
      {
        id: ESCOLA_EDIT_FILTER_MUNICIPAL,
        name: this.props.languageValues.escolaEditTipoDeInstituicaoMunicipal,
      },
      {
        id: ESCOLA_EDIT_FILTER_ESTADUAL,
        name: this.props.languageValues.escolaEditTipoDeInstituicaoEstadual,
      },
      {
        id: ESCOLA_EDIT_FILTER_PRIVADA,
        name: this.props.languageValues.escolaEditTipoDeInstituicaoPrivada,
      },
    ];

    this.allEtapasDaEducacao = [
      {
        id: ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL,
        name: this.props.languageValues.escolaEditEtapasDaEducacaoInfantil,
      },
      {
        id: ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL,
        name: this.props.languageValues
          .escolaEditEtapasDaEducacaoEnsinoFundamental,
      },
      {
        id: ESCOLA_EDIT_FILTER_ENSINO_MEDIO,
        name: this.props.languageValues.escolaEditEtapasDaEducacaoEnsinoMedio,
      },
      {
        id: ESCOLA_EDIT_FILTER_ESPECIALIZADO,
        name: this.props.languageValues.escolaEditEtapasDaEducacaoEspecializado,
      },
      {
        id: ESCOLA_EDIT_FILTER_EJA,
        name: this.props.languageValues.escolaEditEtapasDaEducacaoEja,
      },
      {
        id: ESCOLA_EDIT_FILTER_OUTRO,
        name: this.props.languageValues.escolaEditEtapasDaEducacaoOutro,
      },
    ];

    this.tipoDeInstuicaoOptions = this.allTipoDeInstuicao.map((item) => ({
      label: item.name,
      value: item.id,
    }));

    this.etapaDaEducacaoOptions = this.allEtapasDaEducacao.map((item) => ({
      label: item.name,
      value: item.id,
    }));

    this.setValue = this.setValue.bind(this);
    this.toSubmit = this.toSubmit.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.cancelAndReturnSchools = this.cancelAndReturnSchools.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    let currState = INITIAL_STATE;
    this.props.loadModalidades()

    if (this.editing() && this.props.auth.userPermissions.escolas.edit) {
      currState = {
        ...currState,
        loading: true,
      };

      this.props.loadEscolaById(
        this.props.match.params.id,
        () => {
          if (this._isMounted) {
            this.setState({
              ...this.state,
              loading: false,
              nomeFantasiaChanged: true,
              razaoSocialChanged: true,
              cnpjChanged: true,
              tipoDeInstuicaoChanged: true,
              redeChanged: true,
              etapasDaEducacaoChanged: true,
              modalidadeChanged: true,
              telefoneChanged: true,
              inepChanged: true,
              emailChanged: true,
              coopChanged: true,
              cepChanged: true,
              enderecoChanged: true,
              numeroChanged: true,
              complementoChanged: true,
              bairroChanged: true,
              estadoChanged: true,
              cidadeChanged: true,
            });

            if (this.props.escolas.escolaEditing.idEstado > -1) {
              this.loadCidades(this.props.escolas.escolaEditing.idEstado);
            }
            this.redeIsEdit();
          }
        },
        (error) => {
          if (this._isMounted) {
            if (isAuthorizedRequest(error.response)) {
              SnackbarUtils.enqueueSnackbar({
                message:
                  error.response.statusText ||
                  this.props.languageValues.errorLoadEscolaEditing,
                options: {
                  variant: 'error',
                },
              });
            } else {
              this.setState({
                ...this.state,
                authorizedRequest: false,
              });
            }
          }
        }
      );
    }

    if (
      this.props.auth.userPermissions.escolas.register ||
      this.props.auth.userPermissions.escolas.edit
    ) {
      this.props.loadCooperativas();

      if (
        !this.props.logradouro.estados ||
        this.props.logradouro.estados.length === 0
      ) {
        this.props.loadEstados(() => {
          if (
            this._isMounted &&
            this.props.escolas.escolaEditing.idEstado > -1
          ) {
            this.loadCidades(this.props.escolas.escolaEditing.idEstado);
          }
        });
      }
    }

    if (this._isMounted) {
      this.setState({
        ...this.state,
        ...currState,
      });
    }

    const auth = this.props.auth.userData.profile.perfil;
    const perfilAutorizado = ["pufv_administrador", "pufv_central"];

    if (perfilAutorizado.includes(auth)) {
      this.setState({ permiteCadastroRede: true, loadingRedes: true });
    }

    const carregarRedes = loadRedes(
      (data) => {
        this.setState({ redes: data, loadingRedes: false });
      },
      () => {
        this.setState({ loadingRedes: false });
      }
    );
    carregarRedes();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  editing() {
    if (
      this.props.match.params &&
      this.props.match.params.id &&
      this.props.match.params.id > -1
    ) {
      return true;
    }
    return false;
  }

  redeIsEdit = () => {
    const { idRede } = this.props.escolas.escolaEditing;
    if (
      this.editing() &&
      Boolean(idRede) &&
      this.state.checkedVinculoRede === false &&
      this.state.redeInicializada === false
    ) {
      this.setState({
        checkedVinculoRede: true,
        checked: true,
        redeInicializada: true
      });
    }
  }

  getTitle() {
    if (this.editing()) {
      return this.props.languageValues.editEscolaTitle;
    }
    return this.props.languageValues.newEscolaTitle;
  }

  setValue(event) {
    const fieldName = event.target.name;
    const lastValue = this.props.escolas.escolaEditing[fieldName];
    const newValue = event.target.value;
    function arraysAreEqual(array1, array2) {
      if (array1.length !== array2.length) {
        return false;
      }
      for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
          return false;
        }
      }
      return true;
    }
    let valueChanged = newValue !== lastValue;

    if (fieldName === 'etapasEducacao') {
      valueChanged = !arraysAreEqual(newValue, lastValue);
    }

    this.setState({
      ...this.state,
      [fieldName + 'Changed']: valueChanged,
    });
    if (fieldName === 'tipoInstituicao') {
      this.setState({ tipoDeInstuicaoChanged: true });
    }
    if (fieldName === 'idRede') {
      this.setState({ redeChanged: true });
    }
    if (fieldName === 'etapasEducacao') {
      this.setState({ etapasDaEducacaoChanged: true });
    }
    if (fieldName === 'modalidade') {
      this.setState({ modalidadeChanged: true });
    }
    this.props.changeEscolaEditingValue(fieldName, newValue);
  }

  getStatusOptions() {
    return this.allTipoDeInstuicao.map((status) => ({
      label: status.name,
      value: status.id,
    }));
  }

  allTipoDeInstuicaoChangedValueIsValid() {
    const value = this.props.escolas.escolaEditing.tipoInstituicao;
    const validation = tipoInstituicaoRequiredIsValid(
      value,
      this.props.languageValues.validations.tipoInstituicao.required
    );
    return validation;
  }

  allRedeChangedValueIsValid() {
    const value = this.props.escolas.escolaEditing.idRede || this.redeSelecionada;
    const validation = redeRequiredIsValid(
      value,
      ""
    );
    return validation;
  }

  allEtapaDaEducacaoChangedValueIsValid() {
    const value = this.props.escolas.escolaEditing.etapasEducacao;
    const required = etapaDaEducacaoRequiredIsValid(
      value,
      this.props.languageValues.validations.etapasEducacao.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  nomeFantasiaValueIsValid() {
    const value = this.props.escolas.escolaEditing.nomeFantasia;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.nomeFantasia.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  razaoSocialValueIsValid() {
    const value = this.props.escolas.escolaEditing.razaoSocial;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.razaoSocial.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  cnpjValueIsValid = () => {
    const masked = this.props.escolas.escolaEditing.cnpj ?? '';
    const unmasked = getUnmaskedValue(masked) ?? '';
    if (unmasked.trim().length === 0) {
      return { status: true };
    }
    const result = cnpjSchema.safeParse(unmasked);
    if (!result.success) {
      return {
        status: false,
        error: result.error.errors?.[0]?.message ?? 'CNPJ inválido',
      };
    }
    return { status: true };
  };

  telefoneValueIsValid() {
    const value = this.props.escolas.escolaEditing.telefone;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.telefone.required
    );
    const length = telefoneIsValid(
      value,
      this.props.languageValues.validations.telefone.length
    );
    if (!required.status) {
      return required;
    }
    if (!length.status) {
      return length;
    }
    return {
      status: true,
    };
  }

  inepValueIsValid() {
    // Validação do INEP - https://www.br.uwc.org/codigo-inep-mec
    const value = this.props.escolas.escolaEditing.inep;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.inep.required
    );
    const length = inepIsValid(
      value,
      this.props.languageValues.validations.inep.length
    );
    if (!required.status) {
      return {
        status: true,
      };
    }
    if (!length.status) {
      return length;
    }
    return {
      status: true,
    };
  }

  emailValueIsValid() {
    const value = this.props.escolas.escolaEditing.email;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.email.required
    );
    const validation = emailIsValid(
      value,
      this.props.languageValues.validations.email.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  }

  cooperativaValueIsValid() {
    const value = this.props.escolas.escolaEditing.coop;
    const required = cooperativaRequiredIsValid(
      value,
      this.props.languageValues.validations.cooperativa.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  cepValueIsValid() {
    const value = this.props.escolas.escolaEditing.cep;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.cep.required
    );
    const length = cepIsValid(
      value,
      this.props.languageValues.validations.cep.length
    );
    if (!required.status) {
      return required;
    }
    if (!length.status) {
      return length;
    }
    return {
      status: true,
    };
  }

  enderecoValueIsValid() {
    const required = requiredIsValid(
      this.props.escolas.escolaEditing.endereco,
      this.props.languageValues.validations.endereco.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  numeroValueIsValid() {
    const value = this.props.escolas.escolaEditing.numero;
    const validation = numeroIsValid(
      value,
      this.props.languageValues.validations.numero.validation,
      this.props.languageValues.validations.numero.length
    );

    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  }

  bairroValueIsValid() {
    const required = requiredIsValid(
      this.props.escolas.escolaEditing.bairro,
      this.props.languageValues.validations.bairro.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  estadoValueIsValid() {
    const required = estadoRequiredIsValid(
      this.props.escolas.escolaEditing.idEstado,
      this.props.languageValues.validations.estado.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  cidadeFieldIsDisabled() {
    return this.props.logradouro.loadingCidades ||
      this.props.escolas.escolaEditing.idEstado === -1
      ? true
      : false;
  }

  cidadeValueIsValid() {
    const required = strCidadeRequiredIsValid(
      this.props.escolas.escolaEditing.cidade,
      this.props.languageValues.validations.cidade.required
    );
    if (!required.status) {
      return required;
    }
    return {
      status: true,
    };
  }

  getEstadoByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter((estado) => {
      if (estado.id === idEstado) {
        return true;
      }
      return false;
    });
    if (estados && estados.length > 0) {
      return estados[0].nome;
    }
    return '';
  }

  getUFByIdEstado(idEstado) {
    const estados = this.props.logradouro.estados.filter((estado) => {
      if (estado.id === idEstado) {
        return true;
      }
      return false;
    });
    if (estados && estados.length > 0) {
      return estados[0].sigla;
    }
    return '';
  }

  getCidades(uf) {
    if (!uf || uf.length === 0) {
      return [];
    }
    return this.props.logradouro.cidades[uf.toLowerCase()] || [];
  }

  loadCidades(idEstado) {
    if (this.getCidades(this.getUFByIdEstado(idEstado)).length === 0) {
      this.props.loadCidadesByEstadoId(
        idEstado,
        this.getUFByIdEstado(idEstado)
      );
    }
  }

  processing() {
    return this.state.sending || this.state.loading ? true : false;
  }

  formIsValid() {
    const validations = [
      this.allTipoDeInstuicaoChangedValueIsValid().status,
      this.allEtapaDaEducacaoChangedValueIsValid().status,
      this.nomeFantasiaValueIsValid().status,
      this.razaoSocialValueIsValid().status,
      this.telefoneValueIsValid().status,
      this.emailValueIsValid().status,
      this.inepValueIsValid().status,
      this.cooperativaValueIsValid().status,
      this.cepValueIsValid().status,
      this.enderecoValueIsValid().status,
      this.numeroValueIsValid().status,
      this.bairroValueIsValid().status,
      this.estadoValueIsValid().status,
      this.cidadeValueIsValid().status,
    ];

    if (this.state.checkedVinculoRede) {
      validations.push(this.allRedeChangedValueIsValid().status);
    }

    if (this.processing() || !allIsTrue(validations)) {
      return false;
    }
    return true;
  }

  backToEscolas() {
    this.props.history.push(escolasRoute.path);
  }

  goToStepTwo(id) {
    if (location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO)) {
      this.props.history.push(
        createEscolaRoute.getURLWithParams(id, EscolaEditTabs.ProgramasEducacionais),
      );
      this.props.setCurrentIndex(EscolaEditTabs.ProgramasEducacionais)
      this.props.resetProgramaValue();
    } else {
      this.props.history.push(
        escolaEditRoute.getURLWithParams(id, EscolaEditTabs.ProgramasEducacionais)
      );
      this.props.setCurrentIndex(EscolaEditTabs.ProgramasEducacionais)
    }
  }

  getEscolasLista = (escolas) => {
    return (
      <CustomTable
        columns={[
          {
            name: 'Nome Fantasia',
          },
          {
            name: 'Razão Social',
          },
        ]}
        lines={escolas.map((escola) => {
          return {
            columns: [
              {
                value: escola.nomeFantasia,
              },
              {
                value: escola.razaoSocial,
              },
            ],
          };
        })}
      />
    );
  };

  handleCadastroEscola(escola) {
    this.props.createEscola(
      escola,
      (resp) => {
        this.goToStepTwo(resp.data.id);
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroSalvarEscola,
          options: {
            variant: 'error',
          },
        });
        this.setState({
          ...this.state,
          sending: false,
        });
      }
    );
  }

  handleUpdateEscola(escola) {
    this.props.saveEscola(
      escola,
      async () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.editing()
            ? this.props.languageValues.successSalvarEscola
            : this.props.languageValues.successCadastrarEscola,
          options: {
            variant: 'success',
          },
        });
        this.props.getProgramaInfo(escola.id);
        this.goToStepTwo(escola.id);
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.erroCadastrarEscola,
          options: {
            variant: 'error',
          },
        });
        this.setState({ sending: false });
      },
    );
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return;
    }
    this.setState({
      ...this.state,
      sending: true,
    });
    const cnpjRaw = getUnmaskedValue(this.props.escolas.escolaEditing.cnpj);
    const escola = {
      id: this.editing() ? this.props.match.params.id : null,
      nomeFantasia: this.props.escolas.escolaEditing.nomeFantasia.trim(),
      razaoSocial: this.props.escolas.escolaEditing.razaoSocial.trim(),
      cnpj: cnpjRaw && cnpjRaw.trim().length > 0 ? cnpjRaw : null,
      telefone: getUnmaskedValue(this.props.escolas.escolaEditing.telefone),
      inep: this.props.escolas.escolaEditing.inep.trim(),
      email: this.props.escolas.escolaEditing.email.trim(),
      coop: this.props.escolas.escolaEditing.coop,
      tipoInstituicao: this.props.escolas.escolaEditing.tipoInstituicao,
      etapasEducacao: this.props.escolas.escolaEditing.etapasEducacao,
      modalidade: this.props.escolas.escolaEditing.modalidade ?? [],
      cep: getUnmaskedValue(this.props.escolas.escolaEditing.cep),
      endereco: this.props.escolas.escolaEditing.endereco.trim(),
      numero: this.props.escolas.escolaEditing.numero.trim(),
      idRede: this.props.escolas?.escolaEditing?.idRede ?? this.redeSelecionada ?? null,
      complemento:
        this.props.escolas.escolaEditing.complemento.trim().length === 0
          ? this.props.languageValues.naoInformado
          : this.props.escolas.escolaEditing.complemento.trim(),
      bairro: this.props.escolas.escolaEditing.bairro.trim(),
      estado: this.props.escolas.escolaEditing.estado,
      idEstado: this.props.escolas.escolaEditing.idEstado,
      cidade: this.props.escolas.escolaEditing.cidade,
    };

    if (this.editing()) {
      this.handleUpdateEscola(escola);
    } else {
      this.props.checkSemelhantes(escola.idEstado, escola.cidade, (resp) => {
        if (resp.data.length > 0) {
          this.props.openModal(ConfirmModal, {
            title: this.props.languageValues.verificaEscolasSemelhantes.title,
            content: (
              <div>
                {
                  this.props.languageValues.verificaEscolasSemelhantes
                    .description
                }
                <br />
                <br />
                {this.getEscolasLista(resp.data)}
              </div>
            ),
            cancelLabel:
              this.props.languageValues.verificaEscolasSemelhantes
                .cancelLabelButton,
            confirmLabel:
              this.props.languageValues.verificaEscolasSemelhantes
                .confirmLabelButton,
            cancelCallback: () => {
              this.setState({
                sending: false,
              });
            },
            confirmCallback: () => {
              this.setState(
                {
                  ...this.state,
                  sending: false,
                },
                () => {
                  this.handleCadastroEscola(escola);
                }
              );
            },
          });
        } else {
          this.handleCadastroEscola(escola);
        }
      });
    }
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  cancelAndReturnSchools() {
    this.backToEscolas();
  }

  getRedeOptions() {
    const redes = this.state.redes || [];
    return redes.map((rede) => ({
      label: `${this.formatCNPJListaRede(rede.cnpj)} - ${rede.nome}`,
      value: rede.idRede,
    }));
  }

  resetFormRede = () => {
    this.setState({
      nomeRede: '',
      cnpjRede: '',
      formValid: false,
      redeSelecionada: '',
      formRedeErrors: {
        nomeRede: '',
        cnpjRede: ''
      }
    });
  };

  handleVinculoRedeChange = (isChecked) => {
    this.setState({ checkedVinculoRede: isChecked });
    if (!isChecked) {
      this.setValue({
        target: {
          name: 'idRede',
          value: null,
        },
      })
      this.setState({ checkedVinculoRede: false });
    }
  };

  formatCNPJListaRede = (cnpj) => {
    if (!cnpj) return '';
    const onlyDigits = cnpj.replace(/\D/g, '');
    if (onlyDigits.length !== 14) return cnpj;
    return onlyDigits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  };

  handleModalRedeClose = () => {
    this.setState({ openModalRede: false });
    this.resetFormRede();
  }

  handleConfirmRede = () => {
    const { nomeRede, cnpjRede } = this.state;

    const errors = {};
    if (!nomeRede) errors.nomeRede = this.props.languageValues.escola;
    if (!cnpjRede) errors.cnpjRede = 'CNPJ é obrigatório';

    if (Object.keys(errors).length > 0) {
      this.setState({ formRedeErrors: errors });
      return;
    }

    const cnpjLimpo = this.cleanCNPJMask(cnpjRede);

    createRede(
      cnpjLimpo,
      nomeRede,
      () => {
        this.setState({ loadingRedes: true });
        const carregarRedes = loadRedes(
          (data) => {
            SnackbarUtils.enqueueSnackbar({
              message: this.props.languageValues.escolaToastSuccess,
              options: {
                variant: 'success',
              },
            });
            this.setState({ redes: data, loadingRedes: false });
          },
          () => {
            this.setState({ loadingRedes: false });
          }
        );
        carregarRedes();
        this.props.loadRedes();
        this.setState({ openModalRede: false });
        this.resetFormRede();
      },
      (error) => {
        const errorMessage = error?.response?.data?.message;
        const errorDetails = error?.response?.data?.details;
        const errorMessageDetails = errorDetails?.length ? errorDetails[0].message : '';
        SnackbarUtils.enqueueSnackbar({
          message: (
            <>
              {errorMessage}
              <br />
              {errorMessageDetails}
            </>
          ),
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  openModalRede = () => {
    this.setState({ openModalRede: true });
  };

  handleNomeRedeChange = (event) => {
    const nomeRede = event.target.value;
    this.setState(
      { nomeRede },
      () => this.verifyFormRedeValidity()
    );
  };

  handleCnpjRedeChange = (event) => {
    const cnpjRede = event.target.value.toUpperCase();
    this.setState(
      { cnpjRede },
      () => this.verifyFormRedeValidity()
    );
  };

  cleanCNPJMask = (cnpj) => {
    return cnpj.replace(/[^\d]/g, '');
  };

  verifyFormRedeValidity = () => {
    const { nomeRede, cnpjRede } = this.state;
    const formRedeErrors = {
      nomeRede: nomeRede.trim() === '' ? 'Campo obrigatório' : '',
      cnpjRede: '',
    };
    try {
      cnpjSchema.parse(cnpjRede);
    } catch (error) {
      formRedeErrors.cnpjRede = error.errors?.[0]?.message || 'CNPJ inválido';
    }
    const isValid = formRedeErrors.nomeRede === '' && formRedeErrors.cnpjRede === '';
    this.setState({ formValid: isValid, formRedeErrors });
  };

  isFormRedeValid = () => {
    const { nomeRede, cnpjRede } = this.state;
    return nomeRede.trim() !== '' && cnpjRede.trim() !== '';
  };

  render() {
    const { modalidades, loadingModalidades } = this.props.escolas;
    const modalidadeOptions = modalidades.map((item) => ({
      label: item.nomeModalidade,
      value: item.tipoModalidade,
    }));

    return this.state.authorizedRequest &&
      /* eslint-disable-next-line */
      ((this.editing() && this.props.auth.userPermissions.escolas.edit) ||
        /* eslint-disable-next-line */
        (!this.editing() &&
          this.props.auth.userPermissions.escolas.register)) ? (
      <>
        <div className={`${rootClassName}-scroll scroll-secondary`}>
          <Container maxWidth={'md'}>
            <div className={`${rootClassName}-containerIntro`}>
              <div className={`${rootClassName}-titleData`}>
                Dados da Escola
              </div>
              <div className={`${rootClassName}-subData`}>
                Preencha os dados da escola.
              </div>
            </div>
          </Container>
          <CustomCard
            CardPropTypes={{
              className: rootClassName + '-card',
            }}
            CardHeaderPropTypes={{
              title: this.getTitle(),
            }}
            sending={this.state.sending || this.state.loading}
          >
            <form
              onSubmit={(event) => {
                event.preventDefault();
                this.toSubmit();
              }}
            >
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'nome-fantasia')}
                    data-testid="nomeFantasia"
                    className="nomeFantasia"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditNomeInstituicao}
                    name='nomeFantasia'
                    value={this.props.escolas.escolaEditing.nomeFantasia}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={NOME_FANTASIA_MAX_LENGTH}
                    helperText={
                      this.state.nomeFantasiaChanged &&
                        !this.nomeFantasiaValueIsValid().status
                        ? this.nomeFantasiaValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.nomeFantasiaChanged &&
                      !this.nomeFantasiaValueIsValid().status
                    }
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'razao-social')}
                    data-testid="razaoSocial"
                    className="razaoSocial"
                    disabled={this.processing()}
                    label={
                      <>
                        {this.props.languageValues.escolaEditRazaoSocial}
                        <HelpButton
                          text={this.props.languageValues.hintRazaoSocial}
                          {...getPropsToLabel()}
                        />
                      </>
                    }
                    name='razaoSocial'
                    value={this.props.escolas.escolaEditing.razaoSocial}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={RAZAO_SOCIAL_MAX_LENGTH}
                    helperText={
                      this.state.razaoSocialChanged &&
                        !this.razaoSocialValueIsValid().status
                        ? this.razaoSocialValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.razaoSocialChanged &&
                      !this.razaoSocialValueIsValid().status
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'cnpj')}
                    data-testid="cnpj"
                    className="cnpj"
                    label={this.props.languageValues.cnpj}
                    name='cnpj'
                    value={this.props.escolas.escolaEditing.cnpj}
                    onChange={(event) => {
                      const raw = event.target.value.toUpperCase();
                      const unmasked = getUnmaskedValue(raw);
                      const hasContent = typeof unmasked === 'string' && unmasked.trim().length > 0;
                      this.setValue({ target: { name: 'cnpj', value: raw } });
                      this.setState({ cnpjChanged: hasContent });
                    }}
                    helperText={
                      this.state.cnpjChanged && !this.cnpjValueIsValid().status
                        ? this.cnpjValueIsValid().error
                        : ''
                    }
                    error={this.state.cnpjChanged && !this.cnpjValueIsValid().status}
                    InputProps={{ inputComponent: CNPJMaskedInput }}
                    disabled={this.processing()}
                  />
                </Col>

                <Col cols={[12, 6, 6, 6, 6]}>
                  <NewAutoCompleteField
                    id="tipoInstituicao"
                    data-testid="tipoInstituicao"
                    className="tipoInstituicao"
                    counter={true}
                    label={this.props.languageValues.escolaEditTipoInstituicao}
                    options={this.tipoDeInstuicaoOptions}
                    value={this.props.escolas.escolaEditing.tipoInstituicao}
                    disabled={this.processing()}
                    name='tipoInstituicao'
                    onChange={(value) => {
                      const currValue = value ? value.value : -1;
                      this.setValue({
                        target: {
                          name: 'tipoInstituicao',
                          value: currValue,
                        },
                      });
                    }}
                    error={
                      this.state.tipoDeInstuicaoChanged &&
                      !this.allTipoDeInstuicaoChangedValueIsValid().status
                    }
                    helperText={
                      this.state.tipoDeInstuicaoChanged &&
                        !this.allTipoDeInstuicaoChangedValueIsValid().status
                        ? this.allTipoDeInstuicaoChangedValueIsValid().error
                        : ''
                    }
                    data-teste={'tipoInstituicao'}
                  />
                </Col>

                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'inep')}
                    data-testid="inep"
                    className="inep"
                    label={this.props.languageValues.escolaEditCodigoINEP}
                    name='inep'
                    type='tel'
                    maxSize={INEP_LENGTH}
                    value={this.props.escolas.escolaEditing.inep}
                    onChange={this.setValue}
                    helperText={
                      this.state.inepChanged && !this.inepValueIsValid().status
                        ? this.inepValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.inepChanged && !this.inepValueIsValid().status
                    }
                    disabled={this.processing()}
                  />
                </Col>

                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'telefone')}
                    data-testid="telefone"
                    className="telefone"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditTelefone}
                    name='telefone'
                    value={this.props.escolas.escolaEditing.telefone}
                    onChange={this.setValue}
                    helperText={
                      this.state.telefoneChanged &&
                        !this.telefoneValueIsValid().status
                        ? this.telefoneValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.telefoneChanged &&
                      !this.telefoneValueIsValid().status
                    }
                    InputProps={{
                      inputComponent: PhoneMaskedInput,
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomSelectEdit
                    id="etapasEducacao"
                    className="etapasEducacao"
                    data-testid="etapasEducacao"
                    disabled={this.processing()}
                    onFocus={() =>
                      this.setState({ etapasDaEducacaoFocused: true })
                    }
                    onBlur={() =>
                      this.setState({ etapasDaEducacaoFocused: false })
                    }
                    label={
                      <>
                        <span
                          className={
                            this.state.etapasDaEducacaoFocused
                              ? 'labelFocus'
                              : this.state.etapasDaEducacaoChanged &&
                                !this.allEtapaDaEducacaoChangedValueIsValid()
                                  .status
                                ? 'labelEmptyValue'
                                : ''
                          }
                        >
                          {this.props.languageValues.escolaEditEtapasEducacao}
                        </span>
                        <HelpButton
                          text={this.props.languageValues.hintEtapaDaEducacao}
                          {...getPropsToLabel()}
                        />
                      </>
                    }
                    name='etapasEducacao'
                    value={this.props.escolas.escolaEditing.etapasEducacao}
                    onChange={(value) => {
                      const currValue = value ? value : -1;
                      this.setValue({
                        target: {
                          name: 'etapasEducacao',
                          value: currValue,
                        },
                      });
                    }}
                    counter={true}
                    options={this.etapaDaEducacaoOptions}
                    error={
                      this.state.etapasDaEducacaoChanged &&
                      !this.allEtapaDaEducacaoChangedValueIsValid().status
                    }
                    helperText={
                      this.state.etapasDaEducacaoChanged &&
                        !this.allEtapaDaEducacaoChangedValueIsValid().status
                        ? this.allEtapaDaEducacaoChangedValueIsValid().error
                        : ''
                    }
                    multiple={true}
                  />
                </Col>

                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomSelectEdit
                    id="modalidade"
                    data-testid="modalidade"
                    className="modalidade"
                    onFocus={() => this.setState({ modalidadeFocused: true })}
                    onBlur={() => this.setState({ modalidadeFocused: false })}
                    label={
                      <>
                        <span
                          className={
                            this.state.modalidadeFocused
                              ? 'labelFocus'
                              : ''
                          }
                        >
                          {this.props.languageValues.escolaEditModalidade}
                        </span>
                      </>
                    }
                    name='modalidade'
                    value={this.props.escolas.escolaEditing.modalidade}
                    onChange={(value) => {
                      const currValue = value ? value : -1;
                      this.setValue({
                        target: {
                          name: 'modalidade',
                          value: currValue,
                        },
                      });
                    }}
                    counter={true}
                    options={modalidadeOptions}
                    multiple={true}
                    disabled={this.processing() || loadingModalidades}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 12, 12, 12, 12]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'email')}
                    data-testid="email"
                    className="email"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditEmail}
                    name='email'
                    value={this.props.escolas.escolaEditing.email}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={EMAIL_MAX_LENGTH}
                    helperText={
                      this.state.emailChanged &&
                        !this.emailValueIsValid().status
                        ? this.emailValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.emailChanged &&
                      !this.emailValueIsValid().status
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <NewAutoCompleteField
                    id={getElementID(rootElementId, 'coop')}
                    data-testid="cooperativa"
                    className="cooperativa"
                    label={this.props.languageValues.escolaEditCooperativa}
                    placeholder={
                      this.props.logradouro.loadingCooperativas
                        ? this.props.languageValues.loadingCooperativas
                        : ''
                    }
                    options={this.props.logradouro.cooperativas.map((item) => {
                      return {
                        label: item.nome,
                        value: item.codigo,
                      };
                    })}
                    value={this.props.escolas.escolaEditing.coop}
                    onChange={(value) => {
                      const currValue = value ? value.value : -1;
                      this.setValue({
                        target: {
                          name: 'coop',
                          value: currValue,
                        },
                      });
                    }}
                    loading={this.props.logradouro.loadingCooperativas}
                    loadingMessage={
                      this.props.languageValues.loadingCooperativas
                    }
                    disabled={
                      this.processing() ||
                      this.props.logradouro.loadingCooperativas ||
                      this.editing()
                    }
                    error={
                      this.state.coopChanged &&
                      !this.cooperativaValueIsValid().status
                    }
                    helperText={
                      this.state.coopChanged &&
                        !this.cooperativaValueIsValid().status
                        ? this.cooperativaValueIsValid().error
                        : ''
                    }
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'cep')}
                    data-testid="cep"
                    className="cep"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditCep}
                    name='cep'
                    value={this.props.escolas.escolaEditing.cep}
                    onChange={this.setValue}
                    helperText={
                      this.state.cepChanged && !this.cepValueIsValid().status
                        ? this.cepValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.cepChanged && !this.cepValueIsValid().status
                    }
                    InputProps={{
                      inputComponent: CEPMaskedInput,
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'endereco')}
                    data-testid="endereco"
                    className="endereco"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditEndereco}
                    name='endereco'
                    value={this.props.escolas.escolaEditing.endereco}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={ENDERECO_MAX_LENGTH}
                    helperText={
                      this.state.enderecoChanged &&
                        !this.enderecoValueIsValid().status
                        ? this.enderecoValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.enderecoChanged &&
                      !this.enderecoValueIsValid().status
                    }
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'numero')}
                    data-testid="numero"
                    className="numero"
                    disabled={this.processing()}
                    label={this.props.languageValues.numero}
                    name='numero'
                    value={this.props.escolas.escolaEditing.numero}
                    onChange={this.setValue}
                    counter={false}
                    maxSize={NUMERO_MAX_LENGTH}
                    helperText={
                      this.state.numeroChanged &&
                        !this.numeroValueIsValid().status
                        ? this.numeroValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.numeroChanged &&
                      !this.numeroValueIsValid().status
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'complemento')}
                    data-testid="complemento"
                    className="complemento"
                    disabled={this.processing()}
                    label={this.props.languageValues.complemento}
                    name='complemento'
                    value={this.props.escolas.escolaEditing.complemento}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={COMPLEMENTO_MAX_LENGTH}
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'bairro')}
                    data-testid="bairro"
                    className="bairro"
                    disabled={this.processing()}
                    label={this.props.languageValues.escolaEditBairro}
                    name='bairro'
                    value={this.props.escolas.escolaEditing.bairro}
                    onChange={this.setValue}
                    counter={true}
                    maxSize={BAIRRO_MAX_LENGTH}
                    helperText={
                      this.state.bairroChanged &&
                        !this.bairroValueIsValid().status
                        ? this.bairroValueIsValid().error
                        : ''
                    }
                    error={
                      this.state.bairroChanged &&
                      !this.bairroValueIsValid().status
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]} className='padding-bottom-20'>
                  <NewAutoCompleteFieldEstados
                    id={getElementID(rootElementId, 'estado')}
                    data-testid="estado"
                    className="estado"
                    label={this.props.languageValues.escolaEditEstado}
                    placeholder={
                      this.props.logradouro.loadingEstados
                        ? this.props.languageValues.loadingEstados
                        : ''
                    }
                    options={this.props.logradouro.estados.map((item) => {
                      return {
                        label: item.nome,
                        value: item.id,
                        sigla: item.sigla,
                      };
                    })}
                    value={this.props.escolas.escolaEditing.idEstado}
                    onChange={(value) => {
                      const currValue =
                        value && value.value > -1 ? value.value : -1;
                      this.setValue({
                        target: {
                          name: 'idEstado',
                          value: currValue,
                        },
                      });
                      this.setValue({
                        target: {
                          name: 'estado',
                          value:
                            currValue > -1
                              ? this.getEstadoByIdEstado(currValue)
                              : '',
                        },
                      });
                      this.setValue({
                        target: {
                          name: 'cidade',
                          value: '',
                        },
                      });
                      window.setTimeout(() => {
                        this.setValue({
                          target: {
                            name: 'estado',
                            value:
                              currValue > -1
                                ? this.getEstadoByIdEstado(currValue)
                                : '',
                          },
                        });
                      }, 1);
                      if (typeof currValue === 'number' && currValue > 0) {
                        this.loadCidades(currValue);
                      }
                    }}
                    loading={this.props.logradouro.loadingEstados}
                    loadingMessage={this.props.languageValues.loadingEstados}
                    disabled={
                      this.processing() || this.props.logradouro.loadingEstados
                    }
                    error={
                      this.state.estadoChanged &&
                      !this.estadoValueIsValid().status
                    }
                    helperText={
                      this.state.estadoChanged &&
                        !this.estadoValueIsValid().status
                        ? this.estadoValueIsValid().error
                        : ''
                    }
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <NewAutoCompleteFieldCidades
                    id={getElementID(rootElementId, 'cidade')}
                    data-testid="cidade"
                    className="cidade"
                    label={this.props.languageValues.escolaEditCidade}
                    placeholder={
                      this.props.logradouro.loadingCidades
                        ? this.props.languageValues.loadingCidades
                        : ''
                    }
                    options={this.getCidades(
                      this.getUFByIdEstado(
                        this.props.escolas.escolaEditing.idEstado
                      )
                    ).map((item) => {
                      return {
                        label: item.nome,
                        value: item.nome,
                      };
                    })}
                    value={this.props.escolas.escolaEditing.cidade}
                    onChange={(value) => {
                      this.setValue({
                        target: {
                          name: 'cidade',
                          value: value && value.label ? value.label : '',
                        },
                      });
                    }}
                    loading={this.props.logradouro.loadingCidades}
                    loadingMessage={this.props.languageValues.loadingCidades}
                    disabled={this.processing() || this.cidadeFieldIsDisabled()}
                    error={
                      this.state.cidadeChanged &&
                      !this.cidadeValueIsValid().status
                    }
                    helperText={
                      this.state.cidadeChanged &&
                        !this.cidadeValueIsValid().status
                        ? this.cidadeValueIsValid().error
                        : ''
                    }
                  />
                </Col>
              </Row>
              <>
                <Row>
                  <Col cols={[12, 12, 6, 6, 6]}>
                    <Typography style={{ textAlign: "left" }}>
                      {this.props.languageValues.escolaEditLabelVinculo}
                    </Typography>
                    <Row className="row-vinculo">
                      <input
                        id="toggle-vinculo"
                        className="checkbox"
                        data-testid="toggle-vinculo"
                        type="checkbox"
                        title="checkbox-vinculo"
                        checked={this.state.checkedVinculoRede}
                        onChange={(e) => this.handleVinculoRedeChange(e.target.checked)}
                        disabled={this.editing() && !this.props.escolas.escolaEditing.permiteAlterarRede}
                      />
                      <Typography style={{ textAlign: "left", marginLeft: 5, fontSize: 14 }}>
                        {this.props.languageValues.escolaEditVinculo}
                      </Typography>
                    </Row>
                  </Col>
                </Row>
                {this.state.checkedVinculoRede && (
                  <>
                    <Row>
                      <Col cols={[12, 12, 12, 12, 12]}>
                        <NewAutoCompleteField
                          id="idRede"
                          data-testid="idRede"
                          label={this.props.languageValues.escolaEditRede}
                          name="idRede"
                          placeholder={this.props.languageValues.escolaPlaceholderRede}
                          options={this.getRedeOptions()}
                          onChange={(selected) => {
                            this.setState({
                              redeSelecionada: selected,
                            });
                            this.setValue({
                              target: {
                                name: 'idRede',
                                value: selected ? selected.value : '',
                              },
                            });
                          }}
                          value={this.props.escolas.escolaEditing?.idRede || this.state.redeSelecionada || ''}
                          loading={
                            this.editing()
                              ? this.props.logradouro.loadingRedes
                              : this.state.loadingRedes
                          }
                          loadingMessage={this.props.languageValues.loadingRedes}
                          error={
                            this.state.redeChanged &&
                            !redeRequiredIsValid(
                              this.props.escolas.escolaEditing.idRede || this.state.redeSelecionada,
                              `${this.props.languageValues.escolaHelperText}`
                            ).status
                          }
                          helperText={
                            this.state.redeChanged &&
                              !redeRequiredIsValid(
                                this.props.escolas.escolaEditing.idRede || this.state.redeSelecionada,
                                `${this.props.languageValues.escolaHelperText}`
                              ).status
                              ? redeRequiredIsValid(
                                this.props.escolas.escolaEditing.idRede || this.state.redeSelecionada,
                                `${this.props.languageValues.escolaHelperText}`
                              ).error
                              : ''
                          }
                          disabled={this.editing() && !this.props.escolas.escolaEditing.permiteAlterarRede} />
                      </Col>
                    </Row>
                    {this.state.permiteCadastroRede && (
                      <>
                        <Row>
                          <Col cols={[12, 12, 6, 6, 6]}>
                            <Typography style={{ textAlign: "left", fontSize: 14 }}>
                              {this.props.languageValues.escolaEditQuestion}
                            </Typography>
                          </Col>
                        </Row><Row>
                          <Button
                            id="idRede-cadastro"
                            className="idRede-cadastro"
                            variant="contained"
                            endIcon={<AddIcon />}
                            onClick={this.openModalRede}
                          >
                            {languageValues.pages.escolas.buttons.cadastrarRede}
                          </Button>
                        </Row>
                      </>
                    )}
                    <Col style={{ backgroundColor: "transparent", height: 70 }} />
                  </>
                )}
              </>
              <Row buttonsRow className='row-container'>
                <Row>
                  <Col cols={[12, 12, 12, 12, 12]}>
                    <div className='legend'>{this.props.languageValues.campoObrigatorio}</div>
                  </Col>
                </Row>
                <Row>
                  <Col cols={[12, 12, 5, 5, 5]}>
                    <CustomButton
                      id={getElementID(rootElementId, 'cancel')}
                      theme='pufvYellow'
                      className={rootClassName + '-cancel-button'}
                      label={this.props.languageValues.cancelButton}
                      onClick={this.handleOpen}
                    />
                  </Col>
                  <Col cols={[12, 12, 5, 5, 5]}>
                    <CustomButton
                      id={getElementID(rootElementId, 'save')}
                      theme='pufvYellow'
                      type='submit'
                      className={rootClassName + '-save-buttom'}
                      variant='contained'
                      label={this.props.languageValues.salvarEProsseguir}
                      disabled={!this.formIsValid()}
                    />
                  </Col>
                </Row>
              </Row>
            </form>
          </CustomCard>
        </div >
        <Modal
          open={this.state.open}
          close={this.handleClose}
          handleBack={this.cancelAndReturnSchools}
          title={languageValues.modals.aviso.title}
          content={languageValues.modals.cancelChangeEtapa.text}
        />
        <Modal
          open={this.state.openModalRede}
          close={this.handleModalRedeClose}
          title={languageValues.modals.rede.title}
          confirmContent={languageValues.modals.rede.button.confirm}
          maxWidth='md'
          content={
            <>
              <div className='modalRede-container-content'>
                <Row>
                  <Col className='modalRede-col' cols={[12, 12, 6, 6, 6]}>
                    <Typography style={{ fontSize: 18, fontWeight: 600, marginRight: 10 }}>
                      {languageValues.modals.rede.text.cadastro}
                    </Typography>
                    <HelpButton
                      text={"teste message tooltip"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className='modalRede-col' cols={[12, 12, 6, 6, 6]}>
                    <Typography style={{ fontSize: 16 }}>
                      {languageValues.modals.rede.text.informe}
                    </Typography>
                  </Col>
                </Row>
                <Row>
                  <Col cols={[12, 6, 6, 6, 6]} style={{ paddingTop: 20 }}>
                    <CustomTextField
                      id="field-nome"
                      label={languageValues.modals.rede.fields.label.nome}
                      placeholder={languageValues.modals.rede.fields.placeholder.nome}
                      name="nomeRede"
                      value={this.state.nomeRede}
                      onChange={this.handleNomeRedeChange}
                      helperText={this.state.formRedeErrors.nomeRede}
                      error={!!this.state.formRedeErrors.nomeRede}
                    />
                  </Col>
                  <Col cols={[12, 6, 6, 6, 6]} style={{ paddingTop: 20 }}>
                    <CustomTextField
                      id="field-cnpj"
                      label={languageValues.modals.rede.fields.label.cnpj}
                      placeholder={languageValues.modals.rede.fields.placeholder.cnpj}
                      name="cnpjRede"
                      value={this.state.cnpjRede}
                      onChange={this.handleCnpjRedeChange}
                      helperText={this.state.formRedeErrors.cnpjRede}
                      error={!!this.state.formRedeErrors.cnpjRede}
                      InputProps={{
                        inputComponent: CNPJMaskedInput
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </>
          }
          onConfirm={this.handleConfirmRede}
          handleBack={this.handleModalRedeClose}
          confirmModalDisable={!this.state.formValid}
        />
      </>
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  escolas: state.escolas,
  logradouro: state.logradouro,
  auth: state.auth,
  steps: state.steps,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadCooperativas,
      loadEstados,
      changeEscolaEditingValue,
      loadCidadesByEstadoId,
      loadRedes,
      createRede,
      loadEscolaById,
      saveEscola,
      createEscola,
      resetProgramaValue,
      clearEscolaEditing,
      setCurrentIndex: setCurrentTab,
      handleNext,
      loadModalidades,
      checkSemelhantes,
      getProgramaInfo,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Informacoes));
